import { Stack, TextField } from "@fluentui/react";
import React, { useState } from "react";
import { textFieldStyles } from "../../../common/views/DefaultStyles";
import { Utils } from "../../../common/views/Utils";

interface ProductCodeProps {
    codes: string[];
    setCodes: (codes: string[]) => void;
}

export default function ProductCodeView({ codes, setCodes }: ProductCodeProps) {
    const [code, setCode] = useState("");
    const [listHash, setListHash] = useState(Utils.getRandomKey());

    const onItemRender = (item: string, index: number) => {
        const wrapperClass = "product-picker-wrapper textbox-group-wrapper textbox-group-others-wrapper";

        return <div style={{ position: "relative" }}>
            <span key={"code-" + index} className={wrapperClass}>{item}</span>
        </div>;
    }

    const onValueChange = (event: any, value: any) => {
        let codes = [];

        if (!Utils.isNullOrEmpty(value)) {
            codes = value.split(',');
        }

        setCode(value);
        setCodes(codes);
        setListHash(Utils.getRandomKey());
    }

    return <>
        <div>
            <TextField
                label="Codes"
                value={code}
                onChange={onValueChange}
                styles={textFieldStyles}
            />
        </div>

        <div className="pv-10" style={{ display: "flex" }}>
            <Stack horizontal className="inlineBlock">
                {codes.map(onItemRender)}
            </Stack>
        </div>
    </>;
}